var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19684_28025)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.25 10.0013H11.25M6.25 6.66797H8.75",
    stroke: "#1778F2",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.0835 16.668C7.95881 17.3927 9.01225 17.8545 10.2197 17.9336C11.1712 17.9961 12.1644 17.996 13.1139 17.9336C13.4408 17.9122 13.7972 17.8352 14.1042 17.7105C14.4456 17.5717 14.6164 17.5023 14.7032 17.5128C14.79 17.5233 14.9159 17.615 15.1677 17.7982C15.6117 18.1213 16.1711 18.3534 17.0006 18.3335C17.42 18.3234 17.6297 18.3183 17.7236 18.1604C17.8175 18.0024 17.7006 17.7837 17.4667 17.3464C17.1423 16.7398 16.9368 16.0454 17.2482 15.489C17.7846 14.6942 18.2401 13.7531 18.3067 12.7366C18.3424 12.1904 18.3424 11.6247 18.3067 11.0786C18.2623 10.4012 18.0979 9.75739 17.8345 9.16797",
    stroke: "#1778F2",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2876 14.5736C13.2506 14.3785 15.6107 12.0071 15.8049 9.02997C15.8429 8.44739 15.8429 7.84406 15.8049 7.26146C15.6107 4.28438 13.2506 1.91298 10.2876 1.71784C9.27675 1.65128 8.22136 1.65141 7.21257 1.71784C4.24961 1.91298 1.88946 4.28438 1.69525 7.26146C1.65725 7.84406 1.65725 8.44739 1.69525 9.02997C1.76598 10.1143 2.25001 11.1182 2.81985 11.966C3.15071 12.5594 2.93236 13.3001 2.58773 13.9471C2.33925 14.4136 2.21501 14.6469 2.31476 14.8154C2.41451 14.9839 2.63735 14.9893 3.08301 15.0001C3.96435 15.0213 4.55865 14.7737 5.0304 14.4291C5.29795 14.2336 5.43173 14.1359 5.52393 14.1247C5.61613 14.1135 5.79758 14.1875 6.16042 14.3356C6.48653 14.4686 6.86518 14.5507 7.21257 14.5736C8.22136 14.6401 9.27675 14.6401 10.2876 14.5736Z",
    stroke: "#1778F2",
    strokeWidth: 1.67,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19684_28025"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActive);
export default __webpack_public_path__ + "static/media/active.e2931291a2e1117f5e7cec526d26bcd1.svg";
export { ForwardRef as ReactComponent };